
import { computed, defineComponent, PropType, ref, toRef, watch } from "vue";
import { TranslationService } from "@/core/services/TranslationService";
import VZModal from "@/components/content/VZModal.vue";
import { IUser } from "@/interfaces/iUser";
import UserDetail from "@/views/user/views/UserDetail.vue";

export default defineComponent({
  name: "user-detail-modal",
  emits: ["close-detail"],
  components: { VZModal, UserDetail },
  props: {
    value: { type: Boolean, default: false },
    viewName: { type: String, default: "" },
    data: { type: Object as PropType<IUser>, required: true },
    loading: { type: Boolean, default: false },
    showDialog: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const title = computed(() => {
      if (props.data.firstName && props.data.lastName) {
        return `${props.data.firstName} ${props.data.lastName}`;
      }
      return ``;
    });

    const t = (key: string) => {
      return TranslationService.translate(key);
    };
    const close = () => {
      emit("close-detail");
    };
    return {
      t,
      title,
      close,
    };
  },
});
